// extracted by mini-css-extract-plugin
export default {"nextBtn":"TMT_nextBtn__1IGlF","gameHeader":"TMT_gameHeader__-Whek","skipButton":"TMT_skipButton__BTBtd"};